import { MoneyConnectClientAPI } from "./axios-service-creator";

export const StructureNoteAPI = {
  getStructureNote: () => MoneyConnectClientAPI.get("/consolidate/portfolio/structureNote"),
  getStructureNoteDetail: (securityCode) => MoneyConnectClientAPI.post("/consolidate/portfolio/structureNote/detial", { securityCode }),
  getStructureNoteDocuments: () => MoneyConnectClientAPI.get("/consolidate/portfolio/getAllStructureNote"),
};
